import { createContext, useContext, useState } from 'react';

const PosterContext = createContext(null);

export function PosterProvider({ children }) {
    const [posterColors, setPosterColors] = useState(null);
    return (
        <PosterContext.Provider value={{ posterColors, setPosterColors }}>
            {children}
        </PosterContext.Provider>
    );
}

export function usePosterColors() {
    return useContext(PosterContext);
}
